import moment from 'moment';

// Format file size to human-readable format
export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Format date string to readable format
export const formatDate = (dateStr) => {
    return moment(dateStr).format('MMM D, YYYY h:mm A');
};

// Get file icon based on file extension
export const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    
    if (isAudioFile(fileName)) return 'fas fa-file-audio';
    if (isVideoFile(fileName)) return 'fas fa-file-video';
    if (['pdf'].includes(extension)) return 'fas fa-file-pdf';
    if (['doc', 'docx'].includes(extension)) return 'fas fa-file-word';
    if (['xls', 'xlsx', 'csv'].includes(extension)) return 'fas fa-file-excel';
    if (['zip', 'rar', '7z'].includes(extension)) return 'fas fa-file-archive';
    if (['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(extension)) return 'fas fa-file-image';
    
    return 'fas fa-file';
};

// Check if file is an audio file
export const isAudioFile = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    return ['mp3', 'wav', 'ogg', 'flac', 'm4a'].includes(extension);
};

// Check if file is a video file
export const isVideoFile = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    return ['mp4', 'webm', 'mov', 'avi', 'mkv'].includes(extension);
};

// Check if file is a CSV file
export const isCsvFile = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    return extension === 'csv';
};

// Format time seconds to MM:SS format
export const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// Get display file name (remove path prefix)
export const getDisplayFileName = (fullPath) => {
    if (!fullPath) return '';
    const parts = fullPath.split('/');
    return parts[parts.length - 1] || fullPath;
};

// Helper to get type order for sorting
const getTypeOrder = (file) => {
    if (file.isFolder) return 0;
    const name = file.name ? file.name.toLowerCase() : '';
    if (isCsvFile(name)) return 1;
    if (isAudioFile(name)) return 2;
    if (isVideoFile(name)) return 3;
    return 4; // Other files
};

// Sort files according to sort option
export const sortFiles = (files, sortOption) => {
    const sortedFiles = [...files];
    
    switch (sortOption) {
        case 'name-asc':
            return sortedFiles.sort((a, b) => getDisplayFileName(a.name).localeCompare(getDisplayFileName(b.name)));
        case 'name-desc':
            return sortedFiles.sort((a, b) => getDisplayFileName(b.name).localeCompare(getDisplayFileName(a.name)));
        case 'date-desc':
            return sortedFiles.sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified));
        case 'date-asc':
            return sortedFiles.sort((a, b) => new Date(a.lastModified) - new Date(b.lastModified));
        case 'size-desc':
            return sortedFiles.sort((a, b) => b.size - a.size);
        case 'size-asc':
            return sortedFiles.sort((a, b) => a.size - b.size);
        case 'type-asc':
            return sortedFiles.sort((a, b) => getTypeOrder(a) - getTypeOrder(b));
        case 'type-desc':
            return sortedFiles.sort((a, b) => getTypeOrder(b) - getTypeOrder(a));
        default:
            return sortedFiles;
    }
};

// Sort export data for CSV
export const sortExportData = (data, sortOption) => {
    const sortedData = [...data];
    
    switch (sortOption) {
        case 'name-asc':
            return sortedData.sort((a, b) => a.Name.localeCompare(b.Name));
        case 'name-desc':
            return sortedData.sort((a, b) => b.Name.localeCompare(a.Name));
        case 'date-desc':
            return sortedData.sort((a, b) => new Date(b.LastModified) - new Date(a.LastModified));
        case 'date-asc':
            return sortedData.sort((a, b) => new Date(a.LastModified) - new Date(b.LastModified));
        case 'size-desc':
            return sortedData.sort((a, b) => b.Size - a.Size);
        case 'size-asc':
            return sortedData.sort((a, b) => a.Size - b.Size);
        default:
            return sortedData;
    }
}; 